<template>
    <div>
        <el-input ref="editInput" v-model.trim="lineFrom" @input.native="ex" size="mini" clearable @blur="reBack"></el-input>
    </div>
</template>

<script>
export default {
    name: 'EditInput',
    props: {
        line: {
            type: String
        },
        cid: {
            type: Number
        }
    },
    data() {
        return {
            lineFrom: '',
            company_id: '',
            timer_edit_body: null,
        }
    },
    watch: {
        line(n) {
            this.lineFrom = ''
            if (n) {
                this.lineFrom = n
            }
        },
        cid(n) {
            this.company_id = ''
            if (n) {
                this.company_id = n
            }
        },
    },
    methods: {
        ex() {
            this.doEditLineFrom()
        },
        doEditLineFrom() {
            if (this.timer_edit_body) {
                clearTimeout(this.timer_edit_body)
            }
            this.timer_edit_body = setTimeout(() => {
                this.$nextTick(() => {
                    this.execEditLineValue()
                })
            }, 100)
        },
        execEditLineValue() {
            if (!this.company_id) return false
            if (!this.lineFrom) return false
            if (this.lineFrom) {
                if (!['线上', '线下'].includes(this.lineFrom)) {
                    this.$message.error('填写的值只能是线上或者线下！')
                    return false
                }
            }
            this.$axios.post('api/admin/company/edit_com_from', {
                cid: this.company_id,
                lineFrom: this.lineFrom
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.$message.success(data.msg)
                    this.$emit('updateLine', this.lineFrom, this.company_id);
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        reBack() {
            this.$emit('revert')
        }
    },
    mounted() {
        this.$refs.editInput.focus()
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/companies/components/EditInput.vue